/**
 * Docs site base URL (VitePress, apps/docs). The API serves the built help centre at `/docs/` and the Vite dev server proxies
 * `/docs` to the docs dev server, so same-origin works everywhere; VITE_DOCS_URL points elsewhere (e.g. https://docs.keel.app/).
 */
export const DOCS_BASE: string = (import.meta.env.VITE_DOCS_URL as string | undefined) ?? '/docs/';

export const docsUrl = (path = ''): string => DOCS_BASE.replace(/\/?$/, '/') + path.replace(/^\//, '');
